import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router';

import { login } from '../AuthActions';
import { setError } from '../../App/ErrorsActions';

// Import Style
import '../Auth.scss';

class LoginForm extends Component {
  static defaultProps = {
    params: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      show: false,
    };
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.email) {
      this.props.setError({
        data: {
          email: {
            msg: 'error.email.empty',
          },
        },
      });
      return false;
    }

    if (!this.state.password) {
      this.props.setError({
        data: {
          password: {
            msg: 'error.password.empty',
          },
        },
      });
      return false;
    }

    this.props.login({
      email: this.state.email,
      password: this.state.password,
    });
  };

  render() {
    return (
      <form className='form' noValidate onSubmit={this.handleSubmit}>
        <div className='form_container'>
          <label>Email</label>
          <input
            autoFocus
            className='form-control'
            name="email"
            type="email"
            id="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </div>
        <div className='form_container'>
          <label>Password</label>
          <input
            autoFocus
            className='form-control'
            type={this.state.show ? 'text' : 'password'}
            name="password"
            id="password"
            value={this.state.password}
            onChange={this.handleChange}
          />
        </div>
        <div className='link_account create_account'>
          <Link to={`/register${this.props.params}`}>Create new account</Link>
          <Link to="/forgotpassword">Forgot password?</Link>
        </div>
        <Button variant="primary" type="submit">
          Log in
        </Button>
      </form>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (body) => dispatch(login(body)),
    setError: (err) => dispatch(setError(err, { log: false })),
  };
};

export default connect(undefined, mapDispatchToProps)(LoginForm);
